export default {

	//Sectors
	PRIMARY: '1',//Fondamental
	SECONDARY: '2',//Secondaire
	COMPETENCECENTRE: '3',//Centre de compétence

	//Levels
	MINISTRY: '1',//Ministère
	NATIONAL: '2',//Echelon national
	SECTORAL: '3',//Echelon sectoriel
	LOCAL: '4',//Echelon local

	//Message types
	CIRCLE: '1',
	PLATFORM: '2',
	TOPDOWN: '3',
	BOTTOMUP: '4',
	HORIZONTAL: '5',
	EVENT: '6',
	SURVEY: '7',
	REPLY: '8',

	//Question types
	RADIO: '1',
	CHECKBOX: '2',
	TEXT: '3',
	TEXTAREA: '4'
}